// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"5aee5d5d","853":"83011c3c"}[chunkId] + ".chunk.js";
};